export default "__VITE_ASSET__DqDZgXqg__"